// extracted by mini-css-extract-plugin
export default {"GiHamburgerMenu":"SideBarSkeleton_GiHamburgerMenu__N1aKI","sidebarDiv":"SideBarSkeleton_sidebarDiv__APfQG","contentDiv":"SideBarSkeleton_contentDiv__oWs3L"};